import React from "react";

const Clientlogo = () => {
  const NoofClients = [
    "/images/logos/logo1.png",
    "/images/logos/logo2.png",
    "/images/logos/logo3.png",
    "/images/logos/logo4.png",
    "/images/logos/logo5.png",
    "/images/logos/logo6.png",
    "/images/logos/logo7.png",
    "/images/logos/logo1.png",
    "/images/logos/logo2.png",
    "/images/logos/logo3.png",
    "/images/logos/logo4.png",
    "/images/logos/logo5.png",
    "/images/logos/logo6.png",
    "/images/logos/logo7.png",
  ];

  return (
    <div className="w-full bg-F0F4F7 flex justify-center">
      <div className="2xl:container w-full py-6 flex">
        <div className="w-full flex justify-center">
          <div className="flex relative w-full overflow-hidden ">
            <div className="flex w-clientcarousel animate-scroll gap-4">
              {NoofClients.map((item, index) => (
                <div
                  key={index}
                  className="w-[240px] max-w-[250px] flex justify-center gap-5"
                  style={{}}
                >
                  <img
                    src={process.env.PUBLIC_URL + item}
                    alt="client_logo"
                    className="mx-auto my-auto"
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Clientlogo;
